/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Card } from 'react-bootstrap';
import { ArrowNarrowLeftIcon } from '@heroicons/react/solid';
import { Link } from 'react-router-dom';

export interface IGoBackLinkProps {
  goBackText?: string;
  goBackLink?: string;
}

export const GoBackLink = (props: IGoBackLinkProps) => {
  const { goBackLink, goBackText } = props;
  return (
    <p className="text-center">
      <Card.Link
        as={Link}
        to={goBackLink}
        className="d-flex align-items-center justify-content-center"
      >
        <ArrowNarrowLeftIcon className="icon icon-xs me-2" /> {goBackText}
      </Card.Link>
    </p>
  );
};

GoBackLink.defaultProps = {
  goBackText: 'Back to homepage',
  goBackLink: '/product/fhp',
};
